import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { RecoilState, useSetRecoilState } from "recoil";

export const EditRowButton = ({ row, recoilState }: {
    row: any,
    recoilState: RecoilState<any | undefined>
}) => {
    const setEditRow = useSetRecoilState(recoilState);
    return (
        <Button icon={<EditOutlined />}
            onClick={() => {
                setEditRow(row);
            }}
        />)
}